// this exists so we can style non-leva elements with the same CSS variables.
// default leva vars dont get overwritten when we use a theme, so we have to do it ourselves.
// prefixed with jb
// https://codesandbox.io/p/sandbox/leva-theme-j0q0j?file=%2Fsrc%2FApp.jsx

const injectThemes = (overwrite, original) => {
  // console.log("setCSSVariables")
  // document.documentElement.style.setProperty('--jb-leva-colors-elevation2', '#1f1b24');
  for (const type in original) {
    if (
      type === "colors" ||
      type === "colors" ||
      type === "radii" ||
      type === "borderWidths" ||
      type === "custom"
    ) {
      for (const prop in original[type]) {
        // console.log(type,prop)
        const str = `--jb-leva-${type}-${prop}`;
        if (overwrite?.[type]?.[prop]) {
          // console.log(str, overwrite[type][prop])
          document.documentElement.style.setProperty(
            str,
            overwrite[type][prop]
          );
        } else {
          // console.log(str, original[type][prop])
          document.documentElement.style.setProperty(str, original[type][prop]);
        }
      }
    }
  }
  if (overwrite.custom) {
    delete original.custom;
  }
  if (original.custom) {
    delete original.custom;
  }
};

const adjustCSSTitles = (config,theme) => {
  // this will overrite specific clasees in Leva in cases where we dont want ANY titles. Otherwise it leaves a large blank empy div
  // classname probably subject to change for different leva versions.
  const style = document.createElement("style");
  let str;
  str = ``;

  // removes text display & aditional margins
  if (config.hideLevaLables && config.leva.oneLineLabels === true) {
    str += /*CSS*/ `
            .leva-c-iSkYoW {
                display: none !important;
            }
            .leva-c-grzFYX.leva-c-jzsQCy {
                margin: 0 !important;
            }
        `;
  }

  // color picker fix
  // this has issues when in non embed mode
  // when embed its ok!
  if (config.shiftColorPicker && false) {
    // make px respopnd to themes width AND leva.fill is false dont do it
    str += /*CSS*/ `
            .leva-c-enSiWP {
                /* left: 30px !important; */
                transform: translate(120px, 0px)!important;
            }
        `;
  }

  if (config.changeButtonColor && theme.custom["btn-color"]) {
    str += /*CSS*/ `
      .leva-c-ihqPFh {
        background-color:var(--jb-leva-custom-btn-color) !important;
      }
      .warning-component button {
        background-color:var(--jb-leva-custom-btn-color) !important;
      }
  `;
  }
  if (config.useBordersButton) {
    str += /*CSS*/ `
            .leva-c-ihqPFh {
              border-style: solid  !important;
              border-width: 1px   !important;
            }
            .warning-component button {
              border-style: solid  !important;
              border-width: 1px   !important;
            }
        `;
  }

  if (config.useBordersInput) {
    str += /*CSS*/ `
            .leva-c-kXfPOu {
              border-style: solid  !important;
              border-width: 1px   !important;
            }
        `;
  }
  if (config.headerType === "align" && false) {
    // not for mobile???
    str += /*CSS*/ `
          .leva-c-grzFYX {
            margin-top: 0px  !important;
            padding-top: 0px   !important;
          }
      `;
  }
  if (config.useBordersDropdown ) {
    str += /*CSS*/ `
          .leva-c-dkRbIj {
              border-style: solid  !important;
              border-width: 1px   !important;
          }
      `;
  }

  if(config.overrideTickboxSelectColor){
    str+= /*CSS*/ `
        .leva-c-TldsY input:checked + label {
            /* background-color: red !important; */
            background-color: var(--jb-leva-colors-elevation3) !important;
        }
    `;
  }


  style.innerHTML = str;
  if (str !== "") {
    document.head.appendChild(style);
  }
};

const ConfigureStyles = (config, theme, themeDefault) => {
  injectThemes(theme, themeDefault);
  adjustCSSTitles(config,theme);
};

export default ConfigureStyles;
